import { Box, Button, Checkbox, Dialog, DialogActions, Stack, Typography, colors } from "@mui/material";
import { AuthState } from "context/AuthContext";
import { allowAccess } from "utils/userAccessFun";
import { custom, departments } from "data/authData";

const PublishModal = ({ modal, setModal, submitFunction, selectedRow, setSelectedRow }) => {
	const { user } = AuthState();

	const handleCloseModal = () => {
		setModal(false);
		setSelectedRow();
	};
	const handleFormSubmit = async () => {
		if (typeof submitFunction === "function") submitFunction(selectedRow);
	};

	return (
		<Dialog fullWidth maxWidth="md" open={modal} onClose={handleCloseModal}>
			<Box width="95%" margin="auto" pt={2} display="flex" flexWrap="wrap" columnGap={2} rowGap={1}>
				<Typography width="100%" variant="h6">
					PUBLISH SHOOT
				</Typography>

				<DialogActions sx={{ marginLeft: "auto" }}>
					<Button variant="outlined" onClick={handleCloseModal}>
						Cancel
					</Button>
					<Button
						autoFocus
						variant="contained"
						color="success"
						onClick={handleFormSubmit}
						disabled={!allowAccess(custom.SHOOT_PUBLISHER.key, user, departments.STUDIO.key)}>
						Confirm Publish
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default PublishModal;
